export default function animateSales(SVGs, injectorOptions) {
  SVGInjector(SVGs, injectorOptions, function(totalSVGsInjected) {
    // Callback after all SVGs are injected
    // console.log('We injected ' + totalSVGsInjected + ' SVG(s)!');


    //-- Sales animation
    var box1 = $('#conveyoranim #box1').get(0),
            box2 = $('#conveyoranim #box2').get(0),
            box3 = $('#conveyoranim #box3').get(0),
            box4 = $('#conveyoranim #box4').get(0),
            box5 = $('#conveyoranim #box5').get(0),
            box6 = $('#conveyoranim #box6').get(0),
            type1 = $('#conveyoranim #type1').get(0),
            type2 = $('#conveyoranim #type2').get(0),
            type3 = $('#conveyoranim #type3').get(0),
            type4 = $('#conveyoranim #type4').get(0),
            line = $('#conveyoranim #line').get(0);

    var salesAnim = new TimelineMax({repeat: -1})


    salesAnim
            .set(box1, {rotation: 3, opacity: 0, transform: 'translateY(-20px)', transformOrigin: 'center center'})
            .set(box2, {rotation: 3, opacity: 0, transform: 'translateY(-20px)', transformOrigin: 'center center'})
            .set(box3, {
              rotation: 3, opacity: 0, transform: 'translateY(-20px)', transformOrigin:
                      'center center'
            })
            .set(box4, {rotation: 3, opacity: 0, transform: 'translateY(-20px)', transformOrigin: 'center center'})
            .set(box5, {rotation: 3, opacity: 0, transform: 'translateY(-20px)', transformOrigin: 'center center'})
            .set(box6, {rotation: 3, opacity: 0, transform: 'translateY(-20px)', transformOrigin: 'center center'})
            .set(type1, {opacity: 0, transform: 'translateY(20px)'})
            .set(type2, {opacity: 0, transform: 'translateY(20px)'})
            .set(type3, {opacity: 0, transform: 'translateY(20px)'})
            .set(type4, {opacity: 0, transform: 'translateY(20px)'})
            .set(line, {opacity: 0, transform: 'scale(.8)', transformOrigin: 'bottom left'})

            .to(box1, .34, {rotation: 0, transform: 'translateY(0)', opacity: 1, ease: Power2.easeOut})
            .to(box1, 4.5, {transform: 'translateX(440px)', ease: Power0.easeNone})
            .to(box1, .5, {opacity: 0, ease: Power0.easeNone, delay: -.5})

            .to(box2, .34, {rotation: 0, transform: 'translateY(0)', opacity: 1, ease: Power2.easeOut, delay: -4})
            .to(box2, 4.5, {transform: 'translateX(440px)', ease: Power0.easeNone, delay: -3.5})
            .to(box2, .5, {opacity: 0, ease: Power0.easeNone, delay: -.5})

            .to(type1, .5, {transform: 'translateY(0)', opacity: 1, ease: Power2.easeOut, delay: -5})

            .to(box3, .34, {rotation: 0, transform: 'translateY(0)', opacity: 1, ease: Power2.easeOut, delay: -4})
            .to(box3, 4.5, {transform: 'translateX(440px)', ease: Power0.easeNone, delay: -3.5})
            .to(box3, .5, {opacity: 0, ease: Power0.easeNone, delay: -.5})

            .to(type2, .5, {transform: 'translateY(0)', opacity: 1, ease: Power2.easeOut, delay: -5})

            .to(box4, .34, {rotation: 0, transform: 'translateY(0)', opacity: 1, ease: Power2.easeOut, delay: -4})
            .to(box4, 4.5, {transform: 'translateX(440px)', ease: Power0.easeNone, delay: -3.5})
            .to(box4, .5, {opacity: 0, ease: Power0.easeNone, delay: -.5})

            .to(type3, .5, {transform: 'translateY(0)', opacity: 1, ease: Power2.easeOut, delay: -5})

            .to(box5, .34, {rotation: 0, transform: 'translateY(0)', opacity: 1, ease: Power2.easeOut, delay: -4})
            .to(box5, 4.5, {transform: 'translateX(440px)', ease: Power0.easeNone, delay: -3.5})
            .to(box5, .5, {opacity: 0, ease: Power0.easeNone, delay: -.5})

            .to(type4, .5, {transform: 'translateY(0)', opacity: 1, ease: Power2.easeOut, delay: -5})

            .to(box6, .34, {rotation: 0, transform: 'translateY(0)', opacity: 1, ease: Power2.easeOut, delay: -4})
            .to(box6, 4.5, {transform: 'translateX(440px)', ease: Power0.easeNone, delay: -3.5})
            .to(box6, .5, {opacity: 0, ease: Power0.easeNone, delay: -.5})

            .to(type1, .45, {transform: 'translateY(-15px)', opacity: 0, ease: Power2.easeOut, delay: -1.5})
            .to(type2, .45, {transform: 'translateY(-15px)', opacity: 0, ease: Power2.easeOut, delay: -1.3})
            .to(type3, .45, {transform: 'translateY(-15px)', opacity: 0, ease: Power2.easeOut, delay: -1.1})
            .to(type4, .45, {transform: 'translateY(-15px)', opacity: 0, ease: Power2.easeOut, delay: -.9})


    salesAnim.play();


    //-- Rules animation Sales
    var rulescirc1 = $('.rules-anim-s .rules--1 .rules__circl').get(0),
            rulesinner1 = $('.rules-anim-s .rules--1 .rules__inner').get(0),
            rulesicon1 = $('.rules-anim-s .rules--1 .rules__picto1').get(0),
            rulesstep1 = $('.rules-anim-s .rules--1 .rules__step').get(0),
            rulescopy1 = $('.rules-anim-s .rules--1 .rules__desc').get(0),
            rulescirc2 = $('.rules-anim-s .rules--2 .rules__circl').get(0),
            rulesinner2 = $('.rules-anim-s .rules--2 .rules__inner').get(0),
            rulesicon2 = $('.rules-anim-s .rules--2 .rules__picto2').get(0),
            rulesstep2 = $('.rules-anim-s .rules--2 .rules__step').get(0),
            rulescopy2 = $('.rules-anim-s .rules--2 .rules__desc').get(0),
            rulescirc3 = $('.rules-anim-s .rules--3 .rules__circl').get(0),
            rulesinner3 = $('.rules-anim-s .rules--3 .rules__inner').get(0),
            rulesicon3 = $('.rules-anim-s .rules--3 .rules__picto3').get(0),
            rulesstep3 = $('.rules-anim-s .rules--3 .rules__step').get(0),
            rulescopy3 = $('.rules-anim-s .rules--3 .rules__desc').get(0),
            rulesarrow1 = $('.rules-anim-s .rules__arrow--1').get(0),
            rulesarrow2 = $('.rules-anim-s .rules__arrow--2').get(0);

    var rulesAnimSales = new TimelineMax({repeat: 0});

    rulesAnimSales
            .set(rulescirc1, {opacity: 0, transform: 'scale(.5)'})
            .set(rulesinner1, {opacity: 0, transform: 'scale(.5)'})
            .set(rulesicon1, {opacity: 0, transform: 'scale(.7)'})
            .set(rulesstep1, {opacity: 0, transform: 'scale(1.3)'})
            .set(rulescopy1, {opacity: 0, transform: 'translateY(14px)'})
            .set(rulesarrow1, {opacity: 0, transform: 'translateX(-20px)'})
            .set(rulescirc2, {opacity: 0, transform: 'scale(.5)'})
            .set(rulesinner2, {opacity: 0, transform: 'scale(.5)'})
            .set(rulesicon2, {opacity: 0, transform: 'scale(.7)'})
            .set(rulesstep2, {opacity: 0, transform: 'scale(1.3)'})
            .set(rulescopy2, {opacity: 0, transform: 'translateY(14px)'})
            .set(rulesarrow2, {opacity: 0, transform: 'translateX(-20px)'})
            .set(rulescirc3, {opacity: 0, transform: 'scale(.5)'})
            .set(rulesinner3, {opacity: 0, transform: 'scale(.5)'})
            .set(rulesicon3, {opacity: 0, transform: 'scale(.7)'})
            .set(rulesstep3, {opacity: 0, transform: 'scale(1.3)'})
            .set(rulescopy3, {opacity: 0, transform: 'translateY(14px)'})

            .to(rulescirc1, .6, {opacity: 1, transform: 'scale(1)', ease: Power2.easeOut})
            .to(rulesinner1, .6, {opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.4})
            .to(rulesicon1, .8, {opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.3})
            .to(rulesstep1, .4, {opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.2})
            .to(rulescopy1, .8, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut})
            .to(rulesarrow1, .55, {opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut, delay: .2})

            .to(rulescirc2, .6, {opacity: 1, transform: 'scale(1)', ease: Power2.easeOut})
            .to(rulesinner2, .6, {opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.4})
            .to(rulesicon2, .8, {opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.3})
            .to(rulesstep2, .4, {opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.2})
            .to(rulescopy2, .8, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut})
            .to(rulesarrow2, .55, {opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut, delay: .2})

            .to(rulescirc3, .6, {opacity: 1, transform: 'scale(1)', ease: Power2.easeOut})
            .to(rulesinner3, .6, {opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.4})
            .to(rulesicon3, .8, {opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.3})
            .to(rulesstep3, .4, {opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.2})
            .to(rulescopy3, .8, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut})

    rulesAnimSales.play();
    rulesAnimSales.eventCallback("onComplete", startRoundAnimSales);

    //-- Repeat animation once it's done
    function startRoundAnimSales() {
      $('.rules-anim-s .rules__lineover').addClass('active');
      setTimeout(function() {
        $('.rules-anim-s .rules__lineover').removeClass('active');
        rulesAnimSales.pause(0).play();
      }, 7000)
    }

  });

}





